import Container from '@admin/components/container'
import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import Results from './results'
import numeral from 'numeral'
import React from 'react'

class PayoutsField extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    payouts: PropTypes.array,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChoose: () => {},
    onReady: () => {}
  }

  state = {
    selected: []
  }

  _handleChoose = this._handleChoose.bind(this)
  _handleDeselectAll = this._handleDeselectAll.bind(this)
  _handleSelectAll = this._handleSelectAll.bind(this)

  render() {
    const { selected } = this.state
    const total = this._getTotal()
    return (
      <div className="payoutsfield">
        <div className="payoutsfield-selectall">
          <Button { ...this._getSelectAll() } />
        </div>
        <div className="payoutsfield-body">
          <Results { ...this._getResults() } />
        </div>
        <div className="payoutsfield-footer">
          Total: { numeral(total).format('0.00') } {
            selected.length > 0 ? <span>({ selected.length} transactions)</span> : ''
          }
        </div>
      </div>
    )
  }

  componentDidMount() {
    this._handleSelectAll()
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { selected } = this.state
    if(!_.isEqual(selected, prevState.selected)) {
      this._handleChange()
    }
  }
  _getResults() {
    const { payouts } = this.props
    const { selected } = this.state
    return {
      records: payouts,
      selected,
      onChoose: this._handleChoose
    }
  }

  _getPanel() {
    return {
      title: 't(Issue Payouts)',
      leftItems: [
        { label: 't(Cancel)', handler: this._handleCancel }
      ],
      rightItems: [
        { label: 't(Save)', handler: this._handleSave }
      ]
    }
  }

  _getSelectAll() {
    const { payouts } = this.props
    const { selected } = this.state
    return {
      label: payouts.length === selected.length ? 'deselect all' : 'select all',
      className: 'link',
      handler: payouts.length === selected.length ? this._handleDeselectAll : this._handleSelectAll
    }
  }

  _getSelected() {
    const { payouts } = this.props
    const { selected } = this.state
    return payouts.filter((record, index) => {
      return _.includes(selected, index)
    })
  }

  _getTotal() {
    return this._getSelected().reduce((total, record) => {
      return total + Number(record.total)
    }, 0)
  }

  _handleChange() {
    const selected = this._getSelected()
    this.props.onChange(selected.map(record => record.id))
  }

  _handleDeselectAll() {
    this._handleChoose([])
  }

  _handleChoose(selected) {
    this.setState({ selected })
  }

  _handleSelectAll() {
    const { payouts } = this.props
    this._handleChoose(payouts.map((record, index) => index))
  }

}

const mapResources = (props, context) => ({
  payouts: {
    endpoint: '/api/admin/truevail/admin/payouts',
    filter: {
      status: { $eq: 'pending' }
    }
  }
})

export default Container(mapResources)(PayoutsField)
